import { render } from "./ContractLaborManagement.vue?vue&type=template&id=0ce7cc5b&scoped=true&ts=true"
import script from "./ContractLaborManagement.vue?vue&type=script&lang=ts"
export * from "./ContractLaborManagement.vue?vue&type=script&lang=ts"

import "./ContractLaborManagement.vue?vue&type=style&index=0&id=0ce7cc5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce7cc5b"]])

export default __exports__